import { axiosHelper } from 'Services/AxiosHelper';
import { getApiGWTokenCookie } from 'Utils';
import { CardApplicationUpdateModel, GetCardVisaModel } from 'Models';
import { CommonUpdateCommercialStatus4MailBodyData } from 'Config';

const command = 'RI.OnUpdateCommercialStatus4Mail';

const onUpdateCommercialStatus4Mail = async (params: CommonUpdateCommercialStatus4MailBodyData): Promise<any> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onUpdateCommercialStatus4Mail;
